import classNames from "classnames";
import { useState } from "react";
import ChangePassword from "shared/components/dashboard/changePassword";
import styles from "./style.module.scss";

const DashboardSettings = () => {
  const [activeTab, setActiveTab] = useState<string>("updateProfile");

  const tabs = [
    { label: "Update Profile", value: "updateProfile" },
    { label: "Change Password", value: "changePassword" },
  ];

  const handleTabChange = (tabValue: string) => {
    setActiveTab(tabValue);
  };

  return (
    <>
      <div className={classNames(styles.sectionContainer)}>
        <ChangePassword />
      </div>
    </>
  );
};

export default DashboardSettings;
